export default "__VITE_ASSET__bce98670__"